import { styled, Theme } from '@material-ui/core';

export const CustomSpan = styled('span')<Theme>(() => ({
  cursor: 'default',
  color: '#000000',
}));
